import { render, staticRenderFns } from "./auto.desktop.vue?vue&type=template&id=639961f0&scoped=true"
import script from "./auto.desktop.vue?vue&type=script&lang=js"
export * from "./auto.desktop.vue?vue&type=script&lang=js"
import style0 from "./auto.desktop.vue?vue&type=style&index=0&id=639961f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639961f0",
  null
  
)

export default component.exports